import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import {
  CarsFilterHiddenSearchDataProps,
  WizardCarPWAFTNodeOptions,
} from "components/flexComponents/WizardCarPWA/typings";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";
import { isAddCSRFilter } from "components/flexComponents/WizardCarPWA/utils/isAddCSRFilter";

export const CarsFilterHiddenSearchData = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: CarsFilterHiddenSearchDataProps) => {
    const { flexTemplateNode, flexModuleModelStore, context } = props;

    if (flexModuleModelStore && context) {
      const { searchContext } = context;
      const options = normalizeOptionsData(
        flexTemplateNode,
        flexModuleModelStore.getModel(flexTemplateNode.id)
      ) as WizardCarPWAFTNodeOptions;

      if (isAddCSRFilter(options)) {
        switch (searchContext.pageType) {
          case "Travel-Guide-CarRentalCompany":
          case "Car-Rental-Guide-Suppliers":
          case "Car-Rental-Destination-Suppliers":
            return (
              <input type="hidden" name="selVen" value={`["${searchContext.carSupplier.code}"]`} data-testid="selVen" />
            );
          case "Car-Rental-Guide-Car-Class":
            return (
              <input
                type="hidden"
                name="selCC"
                value={`["${searchContext.carClass.toLowerCase()}"]`}
                data-testid="selCC"
              />
            );
          default:
            return null;
        }
      }
    }

    return null;
  })
);
